var React = require('react');

function Treatment (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M544 192c0-35.35-28.65-63.1-64-63.1s-64 28.65-64 63.1c0 29.79 20.44 54.6 48 61.74v98.26c0 70.59-57.42 127.1-128 127.1s-128-57.41-128-127.1v-1.617c80.63-8.162 144-75.65 144-158.4v-143.1c0-6.062-3.422-11.59-8.844-14.31l-64-31.1c-7.891-3.969-17.52-.7187-21.47 7.156C253.7 16.76 256.9 26.35 264.8 30.32L320 57.88v134.1c0 70.59-57.42 127.1-128 127.1S64 262.6 64 192V57.88l55.16-27.56c7.906-3.969 11.11-13.56 7.156-21.47C122.4 .976 112.7-2.274 104.8 1.695l-64 31.1C35.42 36.41 32 41.94 32 48.01v143.1c0 82.74 63.38 150.2 144 158.4v1.617c0 88.22 71.78 159.1 160 159.1s160-71.78 160-159.1V253.7C523.6 246.6 544 221.8 544 192zM480 224c-17.67 0-32-14.33-32-31.1c0-17.67 14.33-31.1 32-31.1s32 14.33 32 31.1C512 209.7 497.7 224 480 224z"}));
}

Treatment.defaultProps = {"viewBox":"0 0 576 512"};

module.exports = Treatment;

Treatment.default = Treatment;
